/* eslint-disable dot-notation */
import React, { useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import { t } from 'utils/translates';

import {
  selectUserName,
  selectAvatarPath,
  selectRating
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { AUTH_KEY_CONST } from '../../../../constants/LocalStorage';

const cookies = new Cookies();

const MainNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_1`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  const ratingDesc = `Рейтинг: ${props.rating.ratingStatusPoints}/${props.rating.ratingStatusPointsTo} (${props.rating.ratingStatusTitle})`;
  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_1">
        <a
          id="sidebar-nav-main"
          className="dropdown-toggle dropdown-toggle-collapse"
          role="button"
          href={null}
          data-toggle="collapse"
          data-parent="#panelGroupMenu"
          aria-expanded="false"
          aria-controls="panelGroupMenu_c_1"
          onClick={props.onToggle}
        >
          <div className="media media_table">
            <div className="media-left avatar-sm">
              <img
                alt=""
                className="media-object avatar avatar-sm"
                src={props.avatar_path}
              />
            </div>
            <div className="media-body media-middle">
              <div
                className="text-caption font-size-xxs text-success text-overflow"
                data-toggle="tooltip"
                data-container="body"
                data-placement="top"
                title=""
                data-original-title={ratingDesc}
              >
                {this.ratingStars}
                <i
                  className={
                    props.rating.rating >= 20 ? 'fa fa-star' : 'fa fa-star-o'
                  }
                />
                <i
                  className={
                    props.rating.rating >= 40 ? 'fa fa-star' : 'fa fa-star-o'
                  }
                />
                <i
                  className={
                    props.rating.rating >= 60 ? 'fa fa-star' : 'fa fa-star-o'
                  }
                />
                <i
                  className={
                    props.rating.rating >= 80 ? 'fa fa-star' : 'fa fa-star-o'
                  }
                />
                <i
                  className={
                    props.rating.rating >= 100 ? 'fa fa-star' : 'fa fa-star-o'
                  }
                />{' '}
                {props.rating.ratingStatusTitle}
              </div>
              <div className="text-overflow" title={props.username}>
                {props.username}
              </div>
            </div>
          </div>
        </a>
      </div>
      <div
        id="panelGroupMenu_c_1"
        className="panel-collapse collapse"
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_2"
      >
        <div className="list-group">
          <NavLink
            to="/main/my-page"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">{t('Моя страница')}</span>
          </NavLink>
          <NavLink
            to="/main/my-rating-and-stat"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              {t('Мои рейтинг, статистика')}
            </span>
          </NavLink>
          <NavLink
            to="/main/my-balance"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">{t('Мой баланс')}</span>
          </NavLink>
          <NavLink
            to="/main/messenger"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">{t('Мои сообщения')}</span>
          </NavLink>
          <NavLink
            to="/main/update-account"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              {t('Редактировать данные')}
            </span>
          </NavLink>
          <NavLink
            to="/main/customize-notifications"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              {t('Настройка уведомления')}
            </span>
          </NavLink>
          <a
            href=""
            onClick={e => {
              e.preventDefault();
              cookies.remove(AUTH_KEY_CONST);
              if (process.env['ENV_TYPE'] === 'production') {
                window.location.href = '/landing/account/logout';
              } else {
                window.location.href = process.env['ROUTE_BASENAME'];
              }
            }}
            className="list-group-item"
          >
            {t('Выйти')}
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  username: selectUserName(state),
  avatar_path: selectAvatarPath(state),
  rating: selectRating(state)
});

MainNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

MainNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  username: PropTypes.string.isRequired,
  avatar_path: PropTypes.string.isRequired,
  rating: PropTypes.shape({
    rating: PropTypes.string.isRequired,
    ratingStatusTitle: PropTypes.string.isRequired,
    ratingStatusPoints: PropTypes.number.isRequired,
    ratingStatusPointsTo: PropTypes.number.isRequired
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(MainNav));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/MainNav.js